import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import LineResult from "./LineResult/LineResult";
import { selectTheme, resetTheme, changeMode } from "../../../modules/search";
import "./ExtendResult.css";

const ExtendResult = props => (
  <div className="extend-result-container">
    <div className="main-label">Comment sera la balade ?</div>
    <div className="results-container">
      {props.results.map(result => (
        <LineResult
          changeMode={() => props.changeMode("inline")}
          selectTheme={() => props.selectTheme(result)}
          resetTheme={() => props.resetTheme()}
          key={result.id}
          result={result}
        />
      ))}
    </div>
  </div>
);

ExtendResult.propTypes = {
  results: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.string,
      color: PropTypes.string,
      data: PropTypes.arrayOf(
        PropTypes.shape({
          time: PropTypes.number,
          distance: PropTypes.number
        })
      )
    })
  ).isRequired,
  selectTheme: PropTypes.func.isRequired,
  resetTheme: PropTypes.func.isRequired,
  changeMode: PropTypes.func.isRequired
};

const mapStateToProps = (state, ownProps) => ({
  results: state.search.results
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ selectTheme, resetTheme, changeMode }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ExtendResult);



// WEBPACK FOOTER //
// ./src/containers/MainCard/ExtendResult/ExtendResult.jsx